import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    b2bWarning:
      '**Your direct debit mandate must be updated**\n\n' +
      'From {0}, direct debits to this IBAN will no longer be possible. Make sure you change your IBAN with this organisation and add a new B2B mandate.\n\n' +
      'Please note: do not revoke this mandate, as it may take some time for the organisations to take into account your change of IBAN. Your next direct debit can still occur on your old IBAN.\n\n' +
      '**See how**',
    coreWarning:
      '**Make sure you update your IBAN with this organisation**\n\n' +
      'From {0}, direct debits on your old IBAN will no longer be possible.\n\n' +
      'Please note: do not revoke this mandate after your change of IBAN, it will be automatically updated for the next direct debit. If you suspend it, future direct debits will be rejected.\n\n' +
      '**See how**',
    warningMultiple:
      '**Direct debit mandates must be updated**\n\n' +
      'As of {0}, direct debits can no longer be made to your old IBAN. Please ensure that you change your IBAN with these organisations.\n\n' +
      '**See how**',
  },
  fr: {
    b2bWarning:
      '**Votre mandat de prélèvement doit être mis à jour**\n\n' +
      'À partir du {0}, les prélèvements sur cet IBAN ne pourront plus avoir lieu. Veillez à modifier votre IBAN auprès de cet organisme et ajouter un nouveau mandat B2B.\n\n' +
      'Attention\u00A0: ne révoquez pas ce mandat, les organismes peuvent mettre du temps à prendre en compte votre changement d’IBAN. Votre prochain prélèvement peut encore avoir lieu sur votre ancien IBAN.\n\n' +
      '**Voir comment faire**',
    coreWarning:
      '**Veillez à mettre à jour votre IBAN auprès de cet organisme**\n\n' +
      'À partir du {0}, les prélèvements sur cet IBAN ne pourront plus avoir lieu.\n\n' +
      'Attention\u00A0: ne révoquez pas ce mandat, il sera automatiquement mis à jour lors du prochain prélèvement. Si vous le suspendez, les futurs prélèvements seront rejetés.\n\n' +
      '**Voir comment faire**',
    warningMultiple:
      '**Des mandats de prélèvements doivent être mis à jour**\n\n' +
      'À partir du {0}, les prélèvements ne pourront plus être effectués sur votre ancien IBAN. Veillez à modifier votre IBAN auprès de ces organismes.\n\n' +
      '**Voir comment faire**',
  },
});

export default locales;
